import { Link, useNavigate } from 'react-router-dom';
import api from "../services/api";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Card, CardContent, Typography, Button, Snackbar, Alert, Box, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Save as IconSave } from "@mui/icons-material";
import { PaperComponentDraggable } from "./PaperComponentDraggable";

import Skill from './Skill';

import { init, activeValidations } from "../redux/skillSlice";

const SkillEdit = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dialogRef = useRef();
    const sliceKey = props.sliceKey;

    useEffect(() => {
        dispatch(init({ sliceKey: sliceKey }));
    }, [dispatch, sliceKey]);

    useEffect(() => {
        if (props.open) {
            setEnabledSave(true);
            setSaved(false)
        }
    }, [props.open, props.id]);

  const skill = useSelector((state) => state.skill[sliceKey]?.entity);
  const skillValidation = useSelector((state) => state.skill[sliceKey]?.validationMessage);

  const [openMessage, setOpenMessage] = useState(false)
  const onCloseMessage = () => { setOpenMessage(!openMessage); }
  const [propsMessage, setPropsMessage] = useState({ severity: "success", message: "" });
  const [enabledSave, setEnabledSave] = useState(true)
  const [idNew, setIdNew] = useState(0)
  const [nameNew, setNameNew] = useState("")
  const [saved, setSaved] = useState(0)
  // El dialogo no se puede editar si la pagina es solo lectura o si ya se guardo.
  const isReadOnly = props.isReadOnly || !enabledSave;

  const postEntity = async () => {
    var dataPost = {
        ...skill
    }

    var ValidationMessages = skillValidation

    if (ValidationMessages.length > 0) {
        dispatch(activeValidations({sliceKey: sliceKey}));

        setPropsMessage({ severity: "error", message: ValidationMessages.join(" - ") })
        setOpenMessage(true);
    }
    else {
        await api.post("/Modelo/AddUpdateDestreza", dataPost)
            .then(response => {
            setPropsMessage({ severity: "success", message: "Se guardaron los datos con exito" })
            setOpenMessage(true);
            setIdNew(parseInt(response.data.data))
            setNameNew(skill.nombre)
            setSaved(true)
            setEnabledSave(false);
        })
        .catch(error => {
        setPropsMessage({ severity: "error", message: "Hubo un error" })
        setOpenMessage(true);
        });
    }
  }
    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"xs"}
            ref={dialogRef}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <Typography variant="h5" component="span">
                    <Box sx={{ fontWeight: 'bold' }}>
                        {(props.id > 0 ? "Editar" : "Registrar") + " Area"}
                    </Box>
                </Typography>
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <div>
                    <Typography gutterBottom component="span">
                        <Box textAlign='center' padding={1}>
                        <Button variant="outlined" size='small' onClick={() => {postEntity()}} disabled={isReadOnly} >
                            Guardar
                            <IconSave />
                        </Button>
                        </Box>
                    </Typography>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <Card >
                                <CardContent sx={{ padding: "0px 10px 10px 10px !important" }}>
                                    <Skill sliceKey={sliceKey} hideInputs={props.hideInputs} id={props.id} autoFocus isReadOnly={isReadOnly} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <Typography component="span">
                        <Box textAlign='center' padding={1}>
                        <Button variant="outlined" size='small' onClick={() => {postEntity()}} disabled={isReadOnly}>
                            Guardar
                            <IconSave />
                        </Button>
                        </Box>
                    </Typography>
                    <Snackbar open={openMessage} autoHideDuration={5000} onClose={onCloseMessage}
                        anchorOrigin={{vertical: "top", horizontal: "center"}}>
                        <Alert onClose={onCloseMessage} severity={propsMessage.severity}>
                            {propsMessage.message}
                        </Alert>
                    </Snackbar>
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={() => {
                    if (saved) {
                        props.setNewSkillSaved(idNew, nameNew);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default SkillEdit;
